module.exports = __webpack_public_path__ + "img/banner.f89bea0b.png";